import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Form from '../../../common/Form';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Input from '../../../common/Form/Input';
import { addAttributes } from '../../../actions/service_request';
import Dependency from '../../../components/Inputs/Dependency';

const formName = 'AssignTicketOwnerShip';

export default function AssignTicketOwnerShip({ owners, ticket_id, org_id, project_id }) {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const submit = (formValues) => {
        const assignTo = {
            id: formValues.assign_to.value,
            value: formValues.assign_to.label
        };
        dispatch(addAttributes({ ticketId: ticket_id, key: 'ticket_owners', payload: { value: [assignTo], label: 'Ticket Owners', remark: formValues.remark }, formName }));
    };


    const methods = useForm({ defaultValues: {}, mode: 'all' });

    const prefill = useMemo(() => {
        return owners[0]
    }, [owners]);

    return (
        <Form
            methods={methods}
            onSubmit={submit}
            submitButtonText={'Submit'}
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
            isLoading={formButtonLoading[formName]}
        >
            <div className='px-2 flex gap-2'>
                <Dependency
                    label='Assign To'
                    name='assign_to'
                    required
                    org_id={org_id}
                    className='w-full'
                    prefill={prefill}
                />
                <Input
                    label='Remark'
                    type={'text'}
                    name='remark'
                    className='w-full'
                />
            </div>
        </Form>
    );
}
